import React, { useEffect } from "react";
import "./LandingPage.css";

import Navbar               from "./sections/Navbar";
import HeroSection          from "./sections/HeroSection";
import MetricsSection       from "./sections/MetricsSection";
import FeatureDetailSection from "./sections/FeatureDetailSection";
import TheQuestion          from "./sections/TheQuestion";
import FieldPlate           from "./sections/FieldPlate";
import AboutSection         from "./sections/About";
import SpacesSection        from "./sections/Spaces";
import CompareSection       from "./sections/CompareSection";
import PricingSection       from "./sections/PricingSection";
import CtaSection           from "./sections/CtaSection";
import Footer               from "./sections/Footer";

export default function LandingPage() {
  useEffect(() => {
    if (window.location.hash) {
      const targetId = window.location.hash.replace("#", "");
      const elem = document.getElementById(targetId);
      if (elem) {
        setTimeout(() => {
          elem.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    }
  }, []);

  return (
    <div className="tfl-root">
      <Navbar />
      <HeroSection />
      <MetricsSection />
      <FeatureDetailSection />
      <TheQuestion />
      <FieldPlate />
      <AboutSection />
      <SpacesSection />
      <CompareSection />
      <PricingSection />
      <CtaSection />
      <Footer />
    </div>
  );
}
